import { Proposal } from "../models"
import { INITIAL_STATE } from "./reducer"
import { InitialState } from "./types"

export const stateHandler = (state: InitialState) => {
    return {
        fetch: () => {
            return {
                ...state,
                isLoading: true,
            }
        },
        fetchSuccess: (payload: Proposal) => {
            return {
                isLoading: false,
                isLoaded: true,
                isFetching: false,
                id: payload.id,
                ...payload.attributes,
            }
        },

        set: (payload: Proposal) => {
            return {
                ...state,
                ...payload.attributes,
                id: payload.id,
            }
        },

        clear: () => {
            return {
                INITIAL_STATE
            }
        },

        sendByEmail: () => {
            return {
                ...state,
                isFetching: true,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/proposal/reducers/handler.ts